import React, { Component } from "react";
import styles from "./Layouts.local.scss";
import classnames from "classnames";
import { connect } from "react-redux";

//  _________________________________
// |                                 |
// |                                 |
// |                                 |
// |                                 |
// |                                 |
// |_________________________________|

class ConclusionSlide extends Component {
  render() {
    const {
      //   // layoutData: { components },
      componentsBackground
      //   // isResponsive,
      //   // isComposition
    } = this.props;

    let { conclusion } = this.props;

    const customBackground = {
      background: componentsBackground,
      transition: "all 5s ease"
    };

    return (
      <div className={`row ${styles.layout}`}>
        <div
          className={classnames(
            "large-12 medium-12 small-12",
            styles.component_block,
            styles.flex_container,
            styles.align_container
          )}
        >
          <div
            className={classnames(
              styles.component_container,
              styles.container_xl_height,
              styles.Conclusion_slide
            )}
            style={customBackground}
          >
            {/*<textarea disabled={true} value={conclusion.content} />*/}
            <span
              dangerouslySetInnerHTML={{
                __html: conclusion.content
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  conclusion: state.presentation.presentationConfig.conclusion
});

export default connect(mapStateToProps)(ConclusionSlide);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Layouts/ConclusionSlide.js